<div class="c-unsecured mb-22" *ngIf="unsecuredStatus?.isUnsecured">
  <div class="c-unsecured__left">
    <div class="c-unsecured__title">
      <p500-ui-icon name="shield-off" class="icon" size="16px"></p500-ui-icon>
      <span class="font-headline-4" i18n="@@common.unsecured_mode">Unsecured Mode</span>
    </div>
  </div>
  <div class="c-unsecured__right">
    <div #timer class="c-unsecured__time"></div>
    <button p500-ui-button color="warn" [disabled]="isLoading" (click)="leaveMode()" i18n="@@common.leave_mode">Leave Mode</button>
  </div>
</div>
